import { CustomValidators } from 'src/app/shared/helpers/custom-validators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from 'src/app/core/services/settings.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Settings } from '../../core/models/settings.model';
import * as utils from '../../shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';
import { DdbbUtils } from '../../shared/helpers/utils';
import { Subscription } from 'rxjs';

@Component({
  selector: 'hbo-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  passwordForgottenForm: FormGroup;
  setPasswordForm: FormGroup;
  firstRegistrationForm: FormGroup;
  step = 'login';
  settings!: Settings;

  settingsServiceLstnr:Subscription = new Subscription;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private loginService: LoginService,
    private settingsService: SettingsService,
    private activatedRoute: ActivatedRoute,
    private configService: ConfigService,
    private ddbbUtils: DdbbUtils
  ) {
    if (localStorage.getItem('user')) {
      if (router.url.includes('password')) {
        const url = this.router.url;
        this.loginService.logOut();
        location.href = url
      }
    }

    this.loginForm = this.fb.group({
      user: [null, Validators.required],
      password: [null, [Validators.required]]
    });

    this.passwordForgottenForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });

    this.setPasswordForm = this.fb.group({
      newPassword: [null, [Validators.required, CustomValidators.passwordValidator]],
      repeatPassword: [null, [Validators.required, CustomValidators.passwordValidator]],
    });

    this.firstRegistrationForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.settingsServiceLstnr = this.settingsService.settingsStore.subscribe(res => {
      if (res && Object.keys(res).length > 0) {
        this.settings = res;

        if (this.settings) {
          // Opciones Login
          const loginContainer = document.querySelector<HTMLElement>('.login-background');

          if ((this.settings.login.wallpaper.background === 'color' && this.settings.login.wallpaper.backgroundColor) ||
            (this.settings.login.wallpaper.background === 'image' && !this.settings.login.wallpaper.backgroundImage.length)) {
            loginContainer?.style.setProperty('--loginBackgroundColor', this.settings.login.wallpaper.backgroundColor);
            loginContainer?.style.setProperty('--loginBackgroundImage', '');
          }
          else if (this.settings.login.wallpaper.background === 'image' && this.settings.login.wallpaper.backgroundImage) {
            loginContainer?.style.setProperty('--loginBackgroundImage', 'url(' + this.settings.login.wallpaper.backgroundImage + ')');
            loginContainer?.style.setProperty('--loginBackgroundColor', '');
          }

          if (this.settings.login.header.backgroundColor) {
            loginContainer?.style.setProperty('--loginHeaderBackgroundColor', this.settings.login.header.backgroundColor);
          }

          if (this.settings.login.form.backgroundColor) {
            loginContainer?.style.setProperty('--loginFormBackgroundColor', this.settings.login.form.backgroundColor);
          }

          // logos
          loginContainer?.style.setProperty('--logo1', 'url(' + this.settings.logo[1]?.image + ')');
          loginContainer?.style.setProperty('--logo2', 'url(' + this.settings.logo[2]?.image + ')');
          loginContainer?.style.setProperty('--logo3', 'url(' + this.settings.logo[3]?.image + ')');
        }
      }

      if (this.router.url.includes('set-password')) {
        this.step = 'set-password'
      }
    });
  }

  ngOnDestroy(){
    this.settingsServiceLstnr.unsubscribe();
  }

  togglePassword(target: string) {
    const input = document.getElementById(target) as HTMLInputElement
    if (input.type === 'password') { input.type = 'text' }
    else if (input.type === 'text') { input.type = 'password' }
  }

  login() {
    this.loginService.login(this.loginForm.value).subscribe({
      next: login => {
        //this.configService.setConfigParamsValue('childEntities', login.user.childEntities);
        let { ...user } = { ...login.user };
        utils.localStorageSetItem('auth', login.auth);
        utils.localStorageSetItem('user', user);
        this.configService.setConfigParamsValue('user', user);
        this.loginService.userStore.next(user);

        // evitamos que si viene de un login con logintoken lo haga 2 veces (ejecuta la del app.component.ts por el cambio de queryparams)
        //if (!this.activatedRoute.snapshot.queryParamMap.get('loginToken')) {
          this.settingsService.get(user.entity.id, 0, utils.objectToBase64({ shop_id: "RANDSTAD1", ancestor: { shop_id: "admin", ancestor: null } })).subscribe(settings => {
            utils.localStorageSetItem('loginToken', settings.loginToken);
            this.settingsService.settingsStore.next(settings);
            this.configService.setConfigParamsValue('userSettings', settings);
          });
        //}
      },
      error: e => {
        switch (e.status) {
          case 404:
            this.loginForm.controls['user'].setErrors({ 'invalidUser': true });
            break;
          default:
            this.loginForm.controls['password'].setErrors({ 'invalidPassword': true });
            break;
        }
      }
    });
  }


  passwordForgotten() {
    this.loginService.passwordForgotten(this.passwordForgottenForm.get('email')?.value).subscribe(res => {
      this.step = 'forgot-sended'
    });
  }

  firstRegistration() {
    this.loginService.resendValidation(this.firstRegistrationForm.get('email')?.value).subscribe({
      next: () => {
        this.step = 'first-registration-sent';
      },
      error: () => {
        this.step = 'first-registration-sent';
      }
    });
  }

  checkPassword() {
    console.log(this.setPasswordForm.controls['newPassword']?.value);
    console.log(this.setPasswordForm.controls['repeatPassword']?.value);

    if (this.setPasswordForm.controls['newPassword'].value !== this.setPasswordForm.controls['repeatPassword'].value) {
      this.setPasswordForm.controls['repeatPassword'].setErrors({ 'notSamePassword': true })
    } else {
      this.setPasswordForm.controls['repeatPassword'].setErrors(null);
    }
  }

  changePassword() {
    this.checkPassword();
    if (this.setPasswordForm.valid) {
      const body = {
        user: this.activatedRoute.snapshot.queryParamMap.get('username'),
        code: this.activatedRoute.snapshot.queryParamMap.get('code'),
        password: this.setPasswordForm.controls['newPassword'].value
      }
      this.loginService.changePassword(this.activatedRoute.snapshot.queryParamMap.get('action')!, body).subscribe({
        next: res => {
          this.step = 'password-set'
        },
        error: e => {
          const errorStr = JSON.stringify(e.error);
          if (errorStr.includes('Verification code expired') || errorStr.includes('Invalid Verification code')) {
            this.step = 'link-expired';
          } else if (errorStr.includes('User is already confirmed')) {
            this.step = 'password-already-set';
          }
        }
      });
    }
  }

}
